var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"blog__articles-badge",style:(_vm.badgeStyles),attrs:{"href":_vm.categoryUrl},domProps:{"textContent":_vm._s(_vm.category.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }